import { FeatureFlagsResponse } from 'types'

export const defaultPostQuoteFeatureFlagValues = {
  show_growth_discounts_feature: false,
  skip_addons_direct: false,
  growth_direct_pricing_module: false,
  growth_pcw_pricing_module: false,
  growth_enable_link_token: false,
} as const

export const defaultPreQuoteFeatureFlagValues = {
  growth_enable_multicar_promo_fields: false,
} as const

export type PostQuoteFlagName = keyof typeof defaultPostQuoteFeatureFlagValues
export type PreQuoteFlagName = keyof typeof defaultPreQuoteFeatureFlagValues

export const postQuoteFlagKeys = Object.keys(
  defaultPostQuoteFeatureFlagValues,
) as PostQuoteFlagName[]
export const preQuoteFlagKeys = Object.keys(defaultPreQuoteFeatureFlagValues) as PreQuoteFlagName[]

export type PostQuoteFeatureFlags = Record<PostQuoteFlagName, boolean>
export type PreQuoteFeatureFlags = Record<PreQuoteFlagName, boolean>

export type PossibleFeatureFlags = Partial<PostQuoteFeatureFlags & PreQuoteFeatureFlags>

export interface FeatureFlagPreQuoteOverrideArgs {
  quoteId: string
  flagName: PreQuoteFlagName
  value: boolean
}

export interface FeatureFlagContextValue {
  preQuoteFeatureFlags: PreQuoteFeatureFlags
  postQuoteFeatureFlags: PostQuoteFeatureFlags
  isPostQuoteFlagsDefault: boolean
  setPreQuotePersistentFeatureFlags: ({
    quoteId,
    flagName,
    value,
  }: FeatureFlagPreQuoteOverrideArgs) => void
  resetPreQuotePersistentFeatureFlags: (quoteId: string) => void
}

export type MapFeatureFlagsArgs<T extends string> = {
  defaultFlags: Record<T, boolean>
  featureFlagsData: FeatureFlagsResponse | undefined
  isSuccess: boolean
}
